import signedFetch from './util/signedFetch.js';

export default (orgId, userIds = []) =>
  signedFetch('bulkPasswordReset', `${__API_BASE__}/org/${encodeURIComponent(orgId)}/users/bulkPasswordReset`, 'POST', {
    userIds
  });
